import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { useSelector, useDispatch } from "react-redux";
import { Alert } from "@mui/material";
import {
  setShowCrossFacilityPatientWarningModal,
  setSelectedCrossFacilityPatient,
} from "app/store/manualUpload/slice/manualUploadSlice";

const CrossFacilityPatientWarningModal = ({ handleConfirm }) => {
  const { showCrossFacilityPatientWarningModal } = useSelector(
    (state) => state.manualUpload
  );

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setShowCrossFacilityPatientWarningModal(false));
    dispatch(setSelectedCrossFacilityPatient(null));
  };

  return (
    <div>
      <ModalWrapper
        show={showCrossFacilityPatientWarningModal}
        showTitle={true}
        showCloseIcon={true}
        headerStyle={{ padding: "4px 24px" }}
        onClose={onClose}
        title={"Cross Facility Report Upload"}
        children={
          <Alert severity="warning" className="mt-2">
            This patient is currently enrolled with another clinic. Proceeding
            with the report upload will be done without access to their full
            profile, and only in read-only mode.
          </Alert>
        }
        actionButtons={[
          {
            label: "Cancel",
            variant: "outlined",
            onClick: onClose,
          },
          {
            label: "Confirm",
            variant: "contained",
            color: "secondary",
            onClick: handleConfirm,
          },
        ]}
      ></ModalWrapper>
    </div>
  );
};

export default CrossFacilityPatientWarningModal;
